// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

export interface Pagination {
    current_page: number;
    page_count?: number;
    page_size?: number;
    total_count?: number;
}

export interface ApiResponse<T> {
    items: T[];
    pagination: Pagination;
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const appApi = createApi({
    reducerPath: 'appApi',
    baseQuery: fetchBaseQuery({baseUrl: '/api/'}),
    tagTypes: [
        'Configuration',
        'Coupon',
        'CustomerLabel',
        'Labels',
        'Depot',
        'XeroDetails',
        'XeroSettingsDetails',
        'XeroContacts',
        'XeroContactsSync',
        'XeroConnectionStatus',
        'XeroTenant',
        'JobmanConnectionStatus',
        'BenchtopMaterials',
        'BenchtopOutsourceMaterials',
        'BenchtopOutsourceMaterialThicknesses',
        'BenchtopOutsourceMaterialDepths',
        'BenchtopOutsourceMaterialPrefix',
        'BenchtopBrands',
        'BenchtopFinishes',
        'BenchtopFormFactors',
        'BenchtopTypes',
        'BenchtopSubstrates',
        'BenchtopPriceCategories',
        'ManufacturerProductDefaults',
        'ProductStyles',
        'BenchtopEdgeProfiles',
        'BenchtopJoins',
        'ManufacturerFonts',
        'ManufacturerPreferences',
        'WebhookSettings',
        'Branding',
        'CustomerDetails',
        'Countries',
        'Predictions',
        'PredictionDetails',
        'CustomerList',
        'ManufacturerDefaults',
        'ManufacturerCountry',
        'Shortcut',
        'PostWoodGlobals',
        'PostWoodBenchtopEdgeInformation',
        'PostWoodBenchtopToolNumbers',
        'PostWoodJobExists',
        'ManufacturerDefaultsData',
        'Surveys',
        'StatementList',
        'MaterialList',
        'MaterialBrandList',
        'MaterialTypeList',
        'MaterialFinishList',
        'MaterialDoorFilters',
        'MaterialSubstrateList',
        'MaterialThicknessList',
        'MaterialPrefixes',
        'CustomerSearch',
        'PaymentSettings',
        'CustomerPaymentSettings',
        'CustomerDepositRules',
        'Receipts',
        'MCPRList',
        'ChatSettings',
        'PlaceholderFaces',
        'QueueJobs',
        'QueueStats',
        'CustomerAllocationSettings',
        'CustomerAllocations',
        'ManufacturerHistory',
        'GlobalHelpSupport',
    ],
    endpoints: () => ({}),
});

export const appApiReducerPath = appApi.reducerPath;
export const appApiReducer = appApi.reducer;
export const appApiMiddleware = appApi.middleware;
